import FooterLogo from './FooterLogo';
import FooterSocialLinks from './FooterSocialLinks';
import FooterLinks from './FooterLinks';
import FooterCopyright from './FooterCopyright';
import { FooterLogoText, FooterSections } from '@/types/types';

interface FooterProps {
  footerLogoData: FooterLogoText;
  footerSectionsData: FooterSections;
}

export default function Footer({
  footerLogoData,
  footerSectionsData,
}: FooterProps) {
  return (
    <footer className='body-copy bg-designer-black mt-auto relative border-t border-designer-border'>
      <div className='mx-auto max-w-screen-2xl px-4 pb-6 pt-12 sm:px-6 lg:px-8 lg:pt-20 text-xs'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:grid-flow-col lg:grid-cols-[auto_1fr_1fr] justify-start items-start'>
          <div className='desktop:max-w-[330px] phone:w-full tablet:w-full columns-1 phone:mr-0  tablet:mr-0 mr-6'>
            <FooterLogo logoData={footerLogoData} />
            <FooterSocialLinks />
          </div>
          <FooterLinks sectionsData={footerSectionsData} />
        </div>
        <FooterCopyright />
      </div>
    </footer>
  );
}
